"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useCallback, useTransition } from "react";
import { useRouter, usePathname, useSearchParams } from "next/navigation";
import { sortings } from "@/utils/SortingUtil";
import TailwindSelect from "./TailwindSelect";
import { sendGTMEvent } from "@next/third-parties/google";
const SortingControls: React.FC = () => {
  const $ = _c(13);
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [isPending, startTransition] = useTransition();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("sort") || "specials";
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const currentSort = t0;
  let t1;
  if ($[2] !== currentSort) {
    t1 = sortings.find(option => option.value === currentSort) || sortings[0];
    $[2] = currentSort;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const selectedOption = t1;
  let t2;
  if ($[4] !== currentSort || $[5] !== pathname || $[6] !== router || $[7] !== searchParams) {
    t2 = selectedOption_0 => {
      sendGTMEvent({
        event: "sort_change",
        previous_sort: currentSort,
        new_sort: selectedOption_0.value,
        sort_label: selectedOption_0.label
      });
      startTransition(() => {
        const params = new URLSearchParams(searchParams);
        params.set("sort", selectedOption_0.value);
        params.delete("page");
        const newUrl = `${pathname}?${params.toString()}`;
        router.push(newUrl);
        router.refresh();
      });
    };
    $[4] = currentSort;
    $[5] = pathname;
    $[6] = router;
    $[7] = searchParams;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const handleSortingChange = t2;
  const t3 = selectedOption || null;
  let t4;
  if ($[9] !== handleSortingChange || $[10] !== isPending || $[11] !== t3) {
    t4 = <div className="t-flex t-items-center t-justify-center"><TailwindSelect options={sortings} value={t3} placeholder="Select Sorting" onChange={handleSortingChange} isLoading={isPending} /></div>;
    $[9] = handleSortingChange;
    $[10] = isPending;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
export default SortingControls;